const masthead = {
  init: function () {
    const _this = this;

    return new Promise((resolve) => {
      this.breakDesktop = 1200;
      this.lastScroll = 0;
      this.bindListeners();
      this.resize(true);
      this.setVisibility();
      this.trapFocus = new TrapFocus({ ele: document.querySelector('#masthead'), activeClass: 'page--menu-open' });
      this.hideAlertFromStorage();

      resolve();
    });
  },

  bindListeners: function () {
    const _this = this;

    this.addScrollListener();
    this.addBurgerListener();
    this.addSubmenuListener();
    this.addResizeListener();
    this.addAlertButtonListener();
    document.addEventListener('keydown', _this.keydownEventListener.bind(_this));
  },

  setVisibility() {
    const overlay = document.querySelector('.load-overlay--initial');
    gsap.to(overlay, {
      opacity: 0,
      duration: 0.35,
      delay: 0.35,
      onComplete: () => {
        overlay._remove();
      },
    });
  },

  addAlertButtonListener: function () {
    const _this = this;
    document.querySelector('body')._addCustomEventListener('click', '.wb-alert__close', _this.hideAlert);
  },

  addResizeListener: function () {
    const _this = this;
    window.addEventListener('resize', _this.resize.bind(_this));
  },

  addScrollListener: function () {
    const _this = this;

    document.addEventListener('scroll', (e) => {
      _this.lastScroll = _this.currentScroll;
      _this.currentScroll = window.scrollY;

      if (document.querySelector('.page--menu-open')) return false;

      // Prevent errors
      if (Math.abs(_this.currentScroll - _this.lastScroll) < 2) return false;

      // Scrolling down
      if (_this.currentScroll > _this.lastScroll && _this.currentScroll > 0) {
        // Fix element if we scroll past its height
        if (_this.currentScroll > _this.eleHeight && !_this.ele.classList.contains('page__header--fixed')) {
          document.querySelector('html').classList.add('page--menu-onscroll');
          _this.ele.classList.add('page__header--fixed', 'page__header--hidden');
          gsap.to(_this.ele, { y: -_this.eleHeight, duration: 0 });
        }

        // Hide element while scrolling down
        if (
          !_this.ele.classList.contains('page__header--hidden') &&
          _this.ele.classList.contains('page__header--fixed')
        ) {
          _this.ele.classList.add('page__header--hidden');
          gsap.to(_this.ele, { y: -_this.eleHeight, duration: 0.15 });
          _this.closeAllTopLevelElements();
        }
      }
      // Scrolling up
      else {
        // Show element while scrolling up
        if (_this.ele.classList.contains('page__header--hidden')) {
          _this.ele.classList.remove('page__header--hidden');
          gsap.to(_this.ele, { y: 0, duration: 0.15 });
        }

        // Release when we reach the top of the page
        if (_this.currentScroll <= _this.eleHeight) {
          document.querySelector('html').classList.remove('page--menu-onscroll');
          _this.ele.classList.remove('page__header--fixed');
        }
      }
    });
  },

  addBurgerListener: function () {
    const _this = this;

    document.querySelector('body')._addCustomEventListener('click', '#burger', (e) => {
      let d = 0.35;

      if (document.querySelector('html').classList.contains('barba-transitioning')) {
        d = 0;
      }
      document.querySelectorAll('html, #masthead').forEach((ele) => ele.classList.toggle('page--menu-open'));
      document.querySelector('.page__header__main')._slideToggle(d);
      e.targetElement._toggleAriaExpanded();
      _this.toggleAlert();

      if (e.targetElement.getAttribute('aria-expanded') == 'false') _this.closeAllTopLevelElements();
    });
  },

  keydownEventListener: function (e) {
    const _this = this;
    let isOpen = document.querySelector('html').classList.contains('page--menu-open');

    if (!isOpen) return;

    switch (e.key) {
      case 'Escape':
        document.querySelector('#burger').click();
        document.querySelector('#burger').focus();
        break;
    }
  },

  resize: function (force = false) {
    const _this = this;
    this.ele = document.querySelector('#masthead');

    if (this.vw != this.oldVw || force) {
      this.oldVw = this.vw;
      this.vw = window.innerWidth;
      this.vh = window.innerHeight;
      this.eleHeight = this.ele.clientHeight;

      this.closeMenu();
      setTimeout(() => {
        this.setHeaderOffset();
      }, 50);
    }

    if (a11y.forcedBreakpoint) {
      document.querySelector('html').classList.remove('page--menu-onscroll');
      this.ele.classList.remove('page__header--fixed', 'page__header--hidden');
      gsap.to(_this.ele, { y: 0, duration: 0 });
    } else if (_this.currentScroll > _this.eleHeight) {
      document.querySelector('html').classList.add('page--menu-onscroll');
      _this.ele.classList.add('page__header--fixed', 'page__header--hidden');
      gsap.to(_this.ele, { y: -_this.eleHeight, duration: 0 });
    }
  },

  toggleAlert: function () {
    const _this = this;
    const alerts = document.querySelectorAll('.wb-alert');
    let alertsHeight = 0;
    const burgerMenuIsOpen = document.querySelector('#burger').getAttribute('aria-expanded') == 'true';

    if (alerts) {
      if (burgerMenuIsOpen) {
        alerts.forEach((ele) => (alertsHeight += ele.clientHeight));
        gsap.to(_this.ele, { top: -alertsHeight, duration: 0.15 });
      } else {
        gsap.to(_this.ele, { top: 0, duration: 0.15 });
      }
    }
  },

  hideAlert: function (e) {
    const alert = e.target.closest('.wb-alert');

    if (alert.classList.contains('wb-alert--bourses')) {
      localStorage.setItem('hideBoursesAlert', 1);
    } else {
      localStorage.setItem('hideAlert', 1);
    }

    alert._hide(0);
  },

  hideAlertFromStorage: function (e) {
    const boursesAlert = localStorage.getItem('hideBoursesAlert');
    const defaultAlert = localStorage.getItem('hideAlert');

    if (boursesAlert) {
      document.querySelector('.wb-alert--bourses')?._hide(0);
    }

    if (defaultAlert) {
      document.querySelector('.wb-alert--default')?._hide(0);
    }
  },

  fixSubmenus: function () {
    const _this = this;

    if (!document.querySelector('html').classList.contains('page--menu-onscroll')) {
      document.querySelectorAll('.menu--main .level-0').forEach((e) => {
        const submenu = e.querySelector('.sub-menu');

        if (submenu) {
          const menuPadding = window.getComputedStyle(_this.ele.querySelector('.container-fluid--gutters')).paddingLeft;
          const menuWidth = _this.ele.clientWidth - parseFloat(menuPadding) * 2;
          const menuItemLeftPosition = e.offsetLeft;
          const submenuWidth = submenu.clientWidth;
          const submenuFitsInContainer = menuItemLeftPosition + submenuWidth < menuWidth;

          if (submenuFitsInContainer) {
            e.classList.remove('menu__item--right');
          } else {
            e.classList.add('menu__item--right');
          }
        }
      });
    }
  },

  addSubmenuListener: function () {
    const _this = this;
    document
      .querySelector('body')
      ._addCustomEventListener('click', '.sub-menu__trigger', _this.toggleSubmenu.bind(_this));
  },

  toggleSubmenu: function (e) {
    const ele = e.targetElement;
    const parent = ele.closest('.menu__item');
    const submenu = ele.nextSibling;

    this.closeAllTopLevelElements(ele);

    parent._toggleAriaExpanded();
    ele._toggleAriaExpanded();
    submenu._slideToggle();
    this.fixSubmenus();
  },

  closeMenu: function () {
    if (document.querySelector('html').classList.contains('page--menu-open')) {
      document.querySelector('#burger').dispatchEvent(new Event('click'));
    }

    this.closeAllTopLevelElements();
  },

  closeAllTopLevelElements: function (ele = false) {
    const parent = ele ? ele.closest('.menu__item') : false;
    const level = ele ? parent.getAttribute('data-level') : 0;
    const parentNav = ele ? ele.closest('nav') : this.ele;

    if (level == 0) {
      parentNav.querySelectorAll('.level-0[aria-expanded="true"] > .sub-menu').forEach((e) => {
        if (e.closest('.level-0') != parent) {
          e._slideUp();
          e.previousSibling.setAttribute('aria-expanded', 'false');
          e.closest('.level-0').setAttribute('aria-expanded', 'false');
        }
      });
    }
  },

  setHeaderOffset: function () {
    const masthead = document.querySelector('#masthead');
    const ref = document.querySelector('.banner') || document.querySelector('main');

    ref.style.paddingTop = '';

    const headerHeight = masthead.offsetHeight;
    const basePadding = parseFloat(window.getComputedStyle(ref).getPropertyValue('padding-top'));
    ref.style.paddingTop = `${basePadding + headerHeight}px`;
  },
};

(function (window, $) {
  $(document).ready(function () {
    masthead.init();
  });

  window.masthead = masthead;
})(window, jQuery);
